module.exports = __webpack_public_path__ + "img/10.fdee0857.png";